const header = () => {
    return ( 
        <div>
            <div className="heading">
                <img src="https://image.flaticon.com/icons/png/512/2132/2132283.png" alt="book-icon" />
                <h1>goodbooks</h1>
             </div>
             <div className="description">
               <p>Check out the list of my favourite books. Select the genre to get started.</p>
            </div>
        </div>
     );
}
 
export default header;